import React from "react"
import styled from "styled-components"
import coverImage from '../../images/ocean.jpg'

const Section = styled.section`
  background-size: cover;
  background-position: center center;
`;

const Synopsis = () => (
  <Section className="py-20 md:h-screen flex items-center justify-center bg-gray-300 relative" style={{backgroundImage: `url(${coverImage})`}}>
    <div className="max-w-screen-md mx-auto p-5 bg-gray-900 bg-opacity-75">
      <h1 className="text-3xl mb-5 font-black font-heading text-white">Synopsis</h1>
      <p className="mb-6 text-gray-300 text-lg">There is a remarkable story about how a human is first reported to have touched one of Baja's "friendly" whales. In 1972, a man named Pachico Mayoral and a friend were out in a small fishing boat in Laguna San Ignacio. Quite unexpectedly, they were approached by a large gray whale that rubbed up against the side of their boat. At first, the two men feared for their lives, but as the whale continued its attentions, Pachico finally reached over the side and touched it.</p>
      <p className="mb-6 text-gray-300 text-lg">Michael is a writer and filmmaker whose pieces have been published in various magazines, journals, and websites. Although he has written on a variety of topics, he particularly loves writing about the ocean because it reminds him of his childhood on the Long Island Sound. </p>
      <p className="mb-6 text-gray-300 text-lg">Alexandra is a Bay Area freelance travel writer and graphic designer. She leads dolphin encounter trips and has explored such places as Hawaii, Mexico, the Caribbean and British Columbia in search of marine mammal life.
</p>
    </div>
  </Section>
)

export default Synopsis